export const REFERENCE_TYPE = {
  REFERENCE_CALL: 'reference_call',
  NAME_DROP: 'name_drop',
  RFP: 'rfp',
} as const;

export type ReferenceType = (typeof REFERENCE_TYPE)[keyof typeof REFERENCE_TYPE];

// gloss
export const REFERENCE_TYPES: readonly ReferenceType[] = Object.values(REFERENCE_TYPE);

// gloss
export const REFERENCE_TYPE_LABELS: Readonly<Record<ReferenceType, string>> = {
  reference_call: 'Reference call',
  name_drop: 'Name drop',
  rfp: 'RFP',
};
